import { render, staticRenderFns } from "./OwalButtonMultistate.vue?vue&type=template&id=6d72e481&scoped=true"
import script from "./OwalButtonMultistate.vue?vue&type=script&lang=js"
export * from "./OwalButtonMultistate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d72e481",
  null
  
)

export default component.exports